<div id="donut{{index}}" #donut class="donut{{index}} h-100 w-100">
    <p *ngIf="!donutData?.length" class="mt">No Data</p>
</div>